module.exports = __webpack_public_path__ + "assets/img/eski.d098e137.png";